import gql from 'graphql-tag';

export const GET_VERIFIED_SCHOOLS = gql`
  query GetVerifiedSchools($query: SchoolQuery!) {
    getVerifiedSchools(query: $query) {
      _id
      address
      iaCredit
      name
      status
      totalStudents
      type
      categories
      contact {
        email
        firstName
        lastName
        phone
      }
    }
  }
`;

export const GET_SINGLE_SCHOOL = gql`
  query GetSchool($getSchoolId: MOID!) {
    getSchool(id: $getSchoolId) {
      _id
      address
      contact {
        email
        firstName
        lastName
        phone
      }
      iaCredit
      type
      createdAt
      updatedAt
    }
  }
`;

export const GET_CLASS_COUNT_BY_SCHOOL = gql`
  query GetClassCountBySchool($query: ClassCountBySchoolInput!) {
    getClassCountBySchool(query: $query) {
      classesCount
      lessonsCount
      studentsCount
      teachersCount
    }
  }
`;

export const GET_SCHOOL_LESSONS_WITH_PROGRESSIONS = gql`
  query GetSchoolLessonsWithProgressions($query: LessonTeacherSchoolQuery) {
    getAllSchoolLessons(query: $query) {
      _id
      name
      progressionsCount
    }
  }
`;
